import React, { forwardRef, lazy, Suspense } from 'react';

import type { MapViewHandle, MapViewProps } from './MapView';

const LazyMapView = lazy(() => import('./MapView'));

const MapView = forwardRef<MapViewHandle, MapViewProps>((props, ref) => (
  <Suspense fallback={null}>
    <LazyMapView {...props} ref={ref} />
  </Suspense>
));

MapView.displayName = 'MapView';

export default MapView;
